// Imports
import { withStyles } from '@material-ui/core'
import React, { PureComponent } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux'
import { messageShow } from '../../common/api/actions'
import PropTypes from "prop-types";
import { createRewards } from '../apiRewards/actions/mutation'
import { Grid, Popover, Pagination, Typography } from '@mui/material';
import { settingDetail } from '../../setting/api/actions/query';
import styles from './styles'
import { listrewards } from "../apiRewards/actions/query";
import { getImageSource } from '../apiRewards/routes'
import Image from '../../common/Image'
import { Dialog, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { checkPermission } from "../../common/Sidebar/checkPermission";
import RewardCard from './RewardCard';

// Component
class Rewards extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      count: 0,
      currencySymbol: '', 
      currentPageActive: 1,
      currentPageExpired: 1,
      rewardsPerPage: 10,
      sortDirection: null,
      sortedRewards: props.rewards,
      popoverAnchor: null,
      selectedProductDetails: [],
      selectedNotificationType: null,
      permissions:{
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      }
    }
  }
  
  async componentDidMount() {
    this.verifyPermissions();
    const { settingDetail } = this.props;
    try {
      const response = await settingDetail(); 
      if (response && response.data) {
        const { data } = response;
        const currencySymbol = data.data.currencyData.symbol; 
        this.setState({
          currencySymbol,
          isLoading: false,
        });
      } else {
        messageShow('Error fetching settings');
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error('Error fetching setting details:', error);
      messageShow('Error fetching settings');
      this.setState({ isLoading: false });
    }
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.rewards !== this.props.rewards) {
      this.setState({ sortedRewards: this.props.rewards });
    }
  }

  verifyPermissions = async () =>{
    console.log("Checking permissions+++++++++++++++++++++++++++++");
      const modulePermissions =await checkPermission("marketing","reward.rewards");

      this.setState({
        permissions: {
            canView: modulePermissions.canView,
            canCreate: modulePermissions.canCreate,
            canEdit: modulePermissions.canEdit,
            canDelete: modulePermissions.canDelete
        }
    }); 
    console.log("Permissions", this.state.permissions);
   }

  handleActivePageChange = (event, pageNumber) => {
    this.setState({ currentPageActive: pageNumber });
  };

  handleExpiredPageChange = (event, pageNumber) => {
    this.setState({ currentPageExpired: pageNumber });
  };

  handleSortByExpiryDate = () => {
    const { sortDirection } = this.state;
    const { rewards } = this.props;
    let newDirection = 'asc';

    if (sortDirection === 'asc') {
      newDirection = 'desc';
    }

    const sortedRewards = [...rewards].sort((a, b) => {
      const dateA = new Date(a.expiryDate);
      const dateB = new Date(b.expiryDate);

      if (newDirection === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    this.setState({
      sortedRewards,
      sortDirection: newDirection,
      currentPage: 1,
    });
  };

  renderSortArrow = () => {
    const { sortDirection } = this.state;
    if (!sortDirection) return null;

    const arrowStyle = {
      color: '#007BFF'
    };

    return (
      <span style={arrowStyle}>
        {sortDirection === 'asc' ? '▲' : '▼'}
      </span>
    );
  };

  handleClone = async (reward) => {

    const { createRewards, messageShow, rewards, refresh } = this.props;

    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    const formattedExpiryDate = expiryDate.toISOString().split('T')[0];

    const clonedReward = {
      ...reward,
      rewardName: `${reward.rewardName} (Clone)`,
      startDate: new Date().toISOString().split('T')[0],
      expiryDate: formattedExpiryDate,
    };

    try {
      const { data } = await createRewards(clonedReward);
      if (data.success) {
        this.setState((prevState) => ({
          rewards: [...(rewards || []), data.data],
        }));
        refresh();
        messageShow('Reward cloned successfully!');
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      console.error('Error cloning Reward:', error);
      messageShow('Error cloning Reward. Please try again.');
    }
  };

  handleSelectReward = (rewardId) => {
    this.props.onSelectReward(rewardId);
  };

  handleSelectAllRewards = () => {
    this.props.onSelectAllRewards(this.state.Rewards);
  };

  isRewardExpired = (reward) => {
    return reward.isExpired;
  };

  handlePopoverOpen = (event, productDetails) => {
    this.setState({
      popoverAnchor: event.currentTarget,
      selectedProductDetails: productDetails,
    });
  };

  handlePopoverClose = () => {
    this.setState({ popoverAnchor: null, selectedProductDetails: [] });
  };

  render() {
    const { currentPage, currentPageActive, currentPageExpired, rewardsPerPage, sortedRewards, popoverAnchor, selectedProductDetails, currencySymbol, permissions } = this.state;
    const { classes, rewards, selectedRewards, messageDialogOpen, closeMessagingDialog, selectedRewardId, notificationPermissions, refresh, history } = this.props;
   
    const open = Boolean(popoverAnchor);
    const activeRewards = sortedRewards.filter(reward => !this.isRewardExpired(reward));
    const expiredRewards = sortedRewards.filter(reward => this.isRewardExpired(reward));

    const indexOfLastActive = currentPageActive * rewardsPerPage;
    const indexOfFirstActive = indexOfLastActive - rewardsPerPage;
    const paginatedActiveRewards = activeRewards.slice(indexOfFirstActive, indexOfLastActive);

    const indexOfLastExpired = currentPageExpired * rewardsPerPage;
    const indexOfFirstExpired = indexOfLastExpired - rewardsPerPage;
    const paginatedExpiredRewards = expiredRewards.slice(indexOfFirstExpired, indexOfLastExpired);
    return (
      <div className={classes.root}>
        {sortedRewards.length === 0 && (
            <Typography variant="h6" sx={{ m: 2, textAlign: 'center' }}>
                No rewards found.
            </Typography>
        )}
        {activeRewards.length > 0 && (
          <>
            <Typography variant="h6" sx={{ m: 2 }}>Active Rewards</Typography>
            <Grid container spacing={2}>
              {paginatedActiveRewards.map(reward => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={reward._id}>
                  <RewardCard
                    reward={reward}
                    currencySymbol={currencySymbol}
                    permissions={permissions}
                    onSelectReward={this.handleSelectReward}
                    onClone={this.handleClone}
                    onOpenMessagingDialog={this.props.openMessagingDialog}
                    refresh={refresh}
                  />
                </Grid>   
              ))}
            </Grid>
            {activeRewards.length > rewardsPerPage && (
             <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
              <Pagination
               count={Math.ceil(activeRewards.length / rewardsPerPage)}
               page={currentPageActive}
               onChange={this.handleActivePageChange}
               color="primary"
               siblingCount={1}
               boundaryCount={1}
              />
             </div>
            )}
          </>
        )}
        {expiredRewards.length > 0 && (
          <>
            <Typography variant="h6" sx={{ m: 2, mt: 4 }}>Expired Rewards</Typography>
            <Grid container spacing={2}>
              {paginatedExpiredRewards.map(reward => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={reward._id}>
                  <RewardCard
                    reward={reward}
                    currencySymbol={currencySymbol}
                    permissions={permissions}
                    onSelectReward={this.handleSelectReward}
                    onClone={this.handleClone}
                    onOpenMessagingDialog={this.props.openMessagingDialog}
                    refresh={refresh}
                  />
                </Grid>
              ))}
            </Grid>
            {expiredRewards.length > rewardsPerPage && (
              <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                <Pagination
                  count={Math.ceil(expiredRewards.length / rewardsPerPage)}
                  page={currentPageExpired}
                  onChange={this.handleExpiredPageChange}
                  color="primary"
                  siblingCount={1}
                  boundaryCount={1}
                />
              </div>
            )}
          </>
        )}
          <Popover
            open={open}
            anchorEl={popoverAnchor}
            onClose={this.handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div style={{ padding: '15px', minWidth: '250px', maxHeight: '230px', overflowY: 'auto' }}>
              {selectedProductDetails.map(({ name, image }, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Image
                    src={getImageSource(`${image}`)}
                    defaultSrc={getImageSource()}
                  />
                  <span style={{ marginLeft: "15px" }}>{name}</span>
                </div>
              ))}
            </div>
          </Popover>
          <Dialog open={messageDialogOpen} onClose={() => { this.setState({ selectedNotificationType: null }); closeMessagingDialog(); }} fullWidth>
            <DialogContent>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                    <Typography variant="h6">Choose Notification Type</Typography>
                    <IconButton aria-label="close" onClick={() => { this.setState({ selectedNotificationType: null }); closeMessagingDialog(); }} size="small">
                      <CloseIcon />
                    </IconButton>
                  </div>
                  {['Email', 'FB Post', 'Push Notification'].map(type => (
                    <button
                      key={type}
                      style={{
                        padding: '10px 12px',
                        marginBottom: '10px',
                        cursor: 'pointer',
                        border: '1px solid #ccc',
                        borderRadius: 4,
                        background: '#f5f5f5'
                      }}
                      onClick={() => {
                        const routeType = type.toLowerCase().replace(/\s+/g, "-");
                        const selectedReward = sortedRewards.find(reward => reward._id === selectedRewardId);
                        history.push({
                          pathname: `/messaging/${routeType}/create`,
                          state: {
                            rewardData: {
                              ...selectedReward,
                              type: "reward",
                            }
                          }
                        });
                        this.setState({ selectedNotificationType: null });
                        closeMessagingDialog();
                      }}
                    >
                      {type}
                    </button>
                  ))}
              </div>
            </DialogContent>
          </Dialog>
      </div>
    )
  }
}
Rewards.propTypes = {
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  createRewards: PropTypes.func.isRequired,
  settingDetail: PropTypes.func.isRequired,
  notificationPermissions: PropTypes.object.isRequired,
};
function listState(state) {
  return {
    rewardsParent: state.rewardsParent,
  };
}

export default connect(listState, {
  listrewards,
  messageShow,
  createRewards,
  settingDetail
})(withRouter(withStyles(styles)(Rewards)))